module.exports = __webpack_public_path__ + "media/images/general/icon_trash-e5cc403e327cc7011513208caaeb6e48.svg";